<template>
  <page-header :main-title="isGainEngagement ? $t('fxRate') : $t('labeling')">
    <template #tabs>
      <div class="d-flex mt-5">
        <router-link
          v-if="classificationStorageExists && !isGainEngagement"
          v-slot="{ isActive }"
          :to="{
            name: 'StorageManager',
            params: { storagePurpose: 'classification', path: [] }
          }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('storage') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="userCanReadEngagementNodeModelGit && showNodeModelGitPages"
          v-slot="{ isActive }"
          :to="{ name: isGainEngagement ? 'FxRateConfig' : 'LabelingConfig' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('configure') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="
            userCanReadEngagementNodeModelGit &&
            showNodeModelGitPages &&
            !isGainEngagement
          "
          v-slot="{ isActive }"
          :to="{ name: 'LabelingBuild' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('build') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="showPipelinePages && !isGainEngagement"
          v-slot="{ isActive }"
          :to="{ name: 'LabelingRun' }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('run') }}</h4>
          </base-tab>
        </router-link>
        <router-link
          v-if="showPipelinePages"
          v-slot="{ isActive }"
          :to="{
            name: isGainEngagement ? 'FxRateMonitor' : 'LabelingMonitor'
          }"
        >
          <base-tab :active="isActive">
            <h4>{{ $t('monitor') }}</h4>
          </base-tab>
        </router-link>
        <div class="horizontal-line mt-2">
          <hr />
        </div>
      </div>
    </template>
    <template #subheader>
      <div class="mt-3">
        <h4
          v-if="routerName == 'LabelingConfig' || routerName == 'FxRateConfig'"
          class="subtitle-2"
        >
          {{ isGainEngagement ? $t('fxRateDesc') : $t('labelingConfigDesc') }}
        </h4>
        <h4 v-else-if="routerName == 'LabelingBuild'" class="subtitle-2">
          {{ $t('labelingBuildDesc') }}
        </h4>
        <h4 v-else-if="routerName == 'LabelingRun'" class="subtitle-2">
          {{ $t('runTabDesc') }}
        </h4>
        <h4
          v-else-if="
            routerName == 'LabelingMonitor' || routerName == 'FxRateMonitor'
          "
          class="subtitle-2"
        >
          {{ $t('monitorTabDesc') }}
        </h4>
      </div>
    </template>
  </page-header>
  <div class="mt-6">
    <router-view />
  </div>
</template>
<script lang="ts">
import PageHeader from '@/components/misc/PageHeader.vue';

import BaseTab from '@/components/tabs/BaseTab.vue';

import { computed, ComputedRef, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

export default {
  name: 'LabelingPage',
  components: {
    PageHeader,
    BaseTab
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    let routerName = ref(router.currentRoute.value.name);

    const isGainEngagement: ComputedRef<boolean> = computed(
      () => store.getters['home/isGainEngagement']
    );

    const showNodeModelApiPages: ComputedRef<boolean> = computed(
      () => store.getters['home/showNodeModelApiPages']
    );
    const showNodeModelGitPages: ComputedRef<boolean> = computed(
      () => store.getters['home/showNodeModelGitPages']
    );
    const showPipelinePages: ComputedRef<boolean> = computed(
      () => store.getters['home/showPipelinePages']
    );
    const userCanReadEngagementNodeModelGit: ComputedRef<boolean> = computed(
      () => store.getters['userPermissions/canReadEngagementNodeModelGit']
    );
    const classificationStorageExists: ComputedRef<boolean> = computed(
      () => store.getters['storage/classificationStorageExists']
    );

    onMounted(async () => {
      await store.dispatch(
        'userPermissions/checkIfCanReadEngagementNodeModelGit'
      );
    });

    return {
      classificationStorageExists,
      isGainEngagement,
      routerName,
      showNodeModelApiPages,
      showNodeModelGitPages,
      showPipelinePages,
      userCanReadEngagementNodeModelGit
    };
  }
};
</script>
